import React, {useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types';
import StepsLoader from "../steps-loader";
import BaseParagraph from "../../base-components/base-paragraph";
import InputField from "../../base-components/base-input";
import StepFooterAction from "../../base-components/step-footer-action";
import t from 'helpers/I18n'
import { BASE_URL } from '../../../env';
// import getStep from '../../../helpers/getStep';

const PageBus = window.PageBus
const IdentityStep = ({ _step_service, error, step_ID, step_URL, next_step, step_form, setDataToContext, getDataFromContext, _get_step_service, getStep }) => {
    
    const form = useRef()
    const data = getDataFromContext(step_ID)
    
    const [isLoading, setIsLoading] = useState(false)
    const [inputData, setInputData] = useState({ ...data })
    const [isValid, setIsValid] = useState(false)

    const getInputValue = (name, value) => {
        setInputData({
            ...inputData,
            [name] : value
        })
        setDataToContext(step_ID, step_URL, name, value)
    }

    useEffect(()=> {
        setIsValid(isValidForm())
    }, [inputData])

    useEffect(() => {
        getStep(["first_name", "last_name"]).then(res => setInputData({...res}))
        getStep("first_name").then(res => console.log("text =>" , res))

        if (PageBus) {
            PageBus.publish("analyticsServices", {  
                pageID: "onboarding",
                stepSeq: "1",
                stepName: "personal info:name",
                eventAction: "flowStart",
                flowType: "sales",
                flowName: "onboarding",
                productName: "onboarding",
                trackMethod: "flow"
             }
            );
        }
    }, [])

    const action = () => {
         _step_service({step_ID, setIsLoading, next_step})
    }

    const isValidForm = () => {
       return [...form.current.elements].every(element => {
            return element.value !== "" && element.value !== " "
        })
    }
    return (
        <StepsLoader step_ID={step_ID} loading={isLoading}>
                <form ref={form}>
                    <BaseParagraph>
                        <h3>{t('personal_infos.personal_info_name.title')}</h3>
                        {step_form.map(input => (
                        <InputField
                            label={t(input.label)}
                            value={inputData[input.id] !== "NULL" && inputData[input.id]}
                            name={input.id}
                            getInputValue={getInputValue}
                            key={input.id}
                            error={error}
                        />))}
                        <small dangerouslySetInnerHTML={{__html: `${t('personal_infos.personal_info_name.text')}` }}></small>
                    </BaseParagraph>
                </form>
                <StepFooterAction caption={t('general.continue')}  action={action} disabled={!isValid} />
            </StepsLoader>
    )
}

IdentityStep.propTypes = {
    error: PropTypes.array,
    _step_service: PropTypes.func,
    step_ID: PropTypes.string,
    step_URL: PropTypes.string,
    next_step: PropTypes.string,
    setDataToContext: PropTypes.any,
    getDataFromContext: PropTypes.any,
    step_form: PropTypes.array,
}

export default IdentityStep